import {Route} from '@angular/router';

import {RouteTrie} from './route_trie';
import {PathLike} from './types';

/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Tapestry Route Hierarchy
 *
 * A wrapper around Angular's native routes arrays
 * that will index each route and it's associated
 * asynchronous loaders onto a Trie.
 *
 * With each route indexed, you can preload any route's
 * JS and CSS assets simply by calling:
 *
 * ```typescript
 * TapestryRouteHierarchy.preload('/path/to/my-route');
 * ```
 */
export class TapestryRouteHierarchy {
  public static Trie = new RouteTrie();

  public static preload(route: PathLike) {
    return this.Trie.preloadPath(route);
  }

  public static fromRoutes(routes: Route[], basePath: string[] = []) {
    for (const route of routes) {
      if (typeof route.path === 'string') {
        basePath.push(route.path);
        this.Trie.indexPath(basePath, this.toPreloader(route));
        if (route.children) {
          this.fromRoutes(route.children, basePath);
        }
        basePath.pop();
      }
    }
    return routes;
  }

  public static registerPreloader(route: PathLike, preloader: () => Promise<any>) {
    return this.Trie.indexPath(route, preloader);
  }

  private static toPreloader(route: Route) {
    return () =>
      new Promise<void>((resolve) => {
        resolve(
          (async () => {
            await (route?.loadChildren?.() || route?.loadComponent?.());
          })(),
        );
      });
  }
}
